export default __webpack_public_path__ + "static/media/maxine_detail6.0dd9be2a.jpg";